import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { loaderConfig, tokens } from '../../constants';
export var getLoaderLabelTypes = size => {
  var labelTypes = {
    sm: 'body-single-line-sm',
    md: 'body-single-line-md',
    lg: 'body-single-line-lg',
    xl: 'body-single-line-lg',
    xxl: 'body-single-line-lg'
  };
  return labelTypes === null || labelTypes === void 0 ? void 0 : labelTypes[size];
};
export var getLoaderStyles = props => {
  var _a, _b;
  var config = props.config,
    labelPosition = props.labelPosition,
    bgColor = props.bgColor,
    size = props.size,
    _props$noPadding = props.noPadding,
    noPadding = _props$noPadding === void 0 ? false : _props$noPadding;
  var paddingToken = (_a = config === null || config === void 0 ? void 0 : config[size]) === null || _a === void 0 ? void 0 : _a.padding;
  var padding = (_b = tokens.spacing) === null || _b === void 0 ? void 0 : _b[paddingToken];
  return StyleSheet.create({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: labelPosition != 'right' ? 'column' : 'row'
    },
    bgColorContainer: Object.assign({
      borderRadius: tokens.borderRadius.BORDER_RADIUS_100,
      backgroundColor: bgColor
    }, !noPadding && {
      padding
    }),
    label: Object.assign(Object.assign({}, labelPosition === 'right' && {
      marginLeft: tokens.spacing.SPACING_12
    }), labelPosition === 'bottom' && {
      marginTop: tokens.spacing.SPACING_12
    })
  });
};
export var getLoaderProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(loaderConfig === null || loaderConfig === void 0 ? void 0 : loaderConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.loader) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};